export default "__VITE_ASSET__DMzn8dSU__"